// V.033 — Shared material-key → lucide icon map so every surface that shows
// a specific material (Delve Bag, Cavern loot, Request Board, Run Summary)
// uses the SAME bespoke glyph as /adventure instead of a generic diamond.
//
// Backend material keys come from `_ADV_MATERIALS` in backend/adventure.py
// and are surfaced on loot items as `mat_key`. Unknown keys fall back to
// a plain Gem so the row still renders cleanly.
import { Pickaxe, Sprout, Flower2, Fish, Diamond, Axe, Shell, Shovel, Telescope, Gem } from "lucide-react";

export const MATERIAL_ICON = {
  ore: Pickaxe,
  herb: Sprout,
  essence: Flower2,
  pearl: Fish,
  gem: Diamond,
  wood: Axe,
  scale: Shell,
  relic_shard: Shovel,
  stardust: Telescope,
};

/** Return the lucide component for a mat_key; falls back to Gem. */
export function materialIcon(matKey) {
  return MATERIAL_ICON[matKey] || Gem;
}
